import { render, staticRenderFns } from "./Vendedores.vue?vue&type=template&id=309a1bc2&scoped=true&"
import script from "./Vendedores.vue?vue&type=script&lang=js&"
export * from "./Vendedores.vue?vue&type=script&lang=js&"
import style0 from "./Vendedores.vue?vue&type=style&index=0&id=309a1bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a1bc2",
  null
  
)

export default component.exports